import { Box } from '@mui/material'
import { styled, type Theme } from '@mui/system'
import { black, grey } from '../../../colors'

interface StyledHighlightBoxProps {
  width?: string
  height?: string
  theme?: Theme
  left?: string | number
  top?: string | number
  transform?: string
  disableHighlight?: boolean
  ml?: string | number
  mt?: string | number
}

const StyledHighlightBoxContainer = styled(Box)<StyledHighlightBoxProps>(({ left, top, width, height }) => ({
  position: 'absolute',
  left: left ?? '50%',
  top: top ?? '50%',
  width,
  height,
  transform: (!left && !top) ? 'translate(-50%, -50%)' : undefined
}))

const StyledHighlightBox = styled(Box)<StyledHighlightBoxProps>(({ left, top }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  left,
  top
}))

const StyledBoxedOffComponent = styled(Box)<StyledHighlightBoxProps>(({ theme, disableHighlight }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  marginBottom: theme.spacing(1),
  borderStyle: 'solid',
  borderWidth: theme.spacing(0.5),
  visibility: disableHighlight ? 'hidden' : 'visible',
  borderRadius: theme.spacing(4)
}))

const NavigationAndPageCountContainer = styled(Box)<StyledHighlightBoxProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: theme.spacing(4),
  alignItems: 'center',
  color: grey[600],
  marginLeft: theme.spacing(2)
}))

const StyledTextBoxComponent = styled(Box)<StyledHighlightBoxProps>(({ theme, ml, mt }) => ({
  boxShadow: `0px 2px 6px ${black[100]}`,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: grey[0],
  borderRadius: theme.spacing(4),
  width: theme.spacing(100),
  mt,
  ml
}))

const titleStyle = (theme: Theme): React.CSSProperties => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: theme.spacing(4),
  marginLeft: theme.spacing(4),
  marginRight: theme.spacing(4)
})

export {
  StyledHighlightBoxContainer,
  StyledHighlightBox,
  StyledBoxedOffComponent,
  NavigationAndPageCountContainer,
  StyledTextBoxComponent,
  titleStyle
}
